import lgL from "./light/ftpserver_light@lg.jpg";
import mdL from "./light/ftpserver_light@md.jpg";
import smL from "./light/ftpserver_light@sm.jpg";
import lgD from "./dark/ftpserver_dark@lg.jpg";
import mdD from "./dark/ftpserver_dark@md.jpg";
import smD from "./dark/ftpserver_dark@sm.jpg";

const ftpserver = {
  light: [lgL, mdL, smL],
  dark: [lgD, mdD, smD],
};

export default ftpserver;
